// extracted by mini-css-extract-plugin
export default {"marker-loader":"photo-marker_marker-loader__sQOh0","loader":"photo-marker_loader__07eeB","l3":"photo-marker_l3__60SsD"};